import {
  PlatformConnectInstagram,
  PlatformConnectTiktok,
  PlatformConnectYoutube,
} from '~/components/PlatformConnect';
import {
  InstagramNoBorderIcon,
  TiktokNoBorderIcon,
  YoutubeNoBorderIcon,
} from '~/components/icons';

import { NameAndPlatformConnection } from './NameAndPlatform.types';

export const SOCIAL_PLATFORM_CONNECTION: NameAndPlatformConnection = {
  instagram: {
    icon: InstagramNoBorderIcon,
    component: PlatformConnectInstagram,
  },
  tiktok: {
    icon: TiktokNoBorderIcon,
    component: PlatformConnectTiktok,
  },
  youtube: {
    icon: YoutubeNoBorderIcon,
    component: PlatformConnectYoutube,
  },
};
